export const STAGING = 'staging';
export const DEVELOPMENT = 'development';
export const PRODUCTION = 'production';
export const INTEGRATION = 'integration';
export const LOCAL = 'localhost';
export const EXTERNAL = 'external';
